<template>
  <div>
    <div v-if="showMask" class="mask fixed l0 r0 t0 b0"></div>
    <div class="main fixed l0 r0 t0 flex aic jcc" v-show="showGif" :style="style">
      <svg class="spinner" width="45px" height="45px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
      </svg>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'v-refresh-loading',
    data () {
      return {
        showMask: false,
        showGif: false,
        style: {
          height: '0px'
        }
      }
    },
    created () {
      bus.$on('pulldownrefreshMove', (obj, y) => {
        Log('h', y - obj.screenY)
        this.showGif = true
        this.style.height = `${y - obj.screenY}px`
      })
      bus.$on('pulldownrefreshStart', () => {
        this.style.height = `135px`
        this.showMask = true
      })
      bus.$on('pulldownrefreshEnd', () => {
        this.showMask = false
        this.showGif = false
        this.style.height = `0px`
      })
    }
  }
</script>

<style scoped lang="scss">
  $offset: 187;
  $duration: 1.4s;

  .spinner {
    animation: rotator $duration linear infinite;
  }

  @keyframes rotator {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(270deg);
    }
  }

  .path {
    stroke-dasharray: $offset;
    stroke-dashoffset: 0;
    transform-origin: center;
    animation: dash $duration ease-in-out infinite,
    colors ($duration *4) ease-in-out infinite;
  }

  @keyframes colors {
    0% {
      stroke: #4285F4;
    }
    /*25% {
      stroke: #DE3E35;
    }
    50% {
      stroke: #F7C223;
    }
    75% {
      stroke: #1B9A59;
    }*/
    100% {
      stroke: #4285F4;
    }
  }

  @keyframes dash {
    0% {
      stroke-dashoffset: $offset;
    }
    50% {
      stroke-dashoffset: $offset / 4;
      transform: rotate(135deg);
    }
    100% {
      stroke-dashoffset: $offset;
      transform: rotate(450deg);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/v-refresh-loading.vue